import { InationalTransportPoint, IProductPick, isSameItem, ItemAtPoint } from "contexts/RequestQuoteContext";
import { Product } from "generated/graphql";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ContainerCounterProduct } from "../shared/Catalog/CatalogStyles";
import { InputCounter, OperationButton } from "../shared/MainStyles";

interface IVehicleCounter {
  product: Product;
  isForDelivery: boolean;
  point: InationalTransportPoint;
  productsChecked: ItemAtPoint[];
  productsToPick: ItemAtPoint[];
  onCounterChanged: boolean;
  onChangeCountValue?: (item: Product, counter: number) => void;
}
export default function CatalogCounter({
  product,
  point,
  productsChecked,
  productsToPick,
  isForDelivery,
  onChangeCountValue,
}: IVehicleCounter) {
  const [count, setCount] = useState(0);

  const getProductCounterMax = useCallback(
    (product: IProductPick) =>
      isForDelivery
        ? getAlreadyDeliveredCount(product) +
        productsToPick?.find((p) => isSameItem(p?.product, product) && product?.pickup === p?.product?.pickup)
          ?.remainder
        : // eslint-disable-next-line eqeqeq
        productsToPick?.find((p) => p?.product?._id == product?._id)?.counter,
    [productsToPick]
  );

  const [maxValue, setMaxValue] = useState(0);
  const [maxDelivery, setMaxDelivery] = useState(0);

  const onChangeValue = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, value: number) => {
    e.preventDefault();
    const newValue = count + value;
    if (newValue >= 1 && newValue <= maxValue) {
      setCount(newValue);
      onChangeCountValue(product, newValue);
    }
  };

  const getAlreadyDeliveredCount = (product: IProductPick) =>
    point?.itemsToDelivered?.find((i) => isSameItem(i?.product, product) && product?.pickup === i?.product?.pickup)
      ?.counter || 0;

  const hasAvailableArticleToDelivery = (product: IProductPick) =>
    isForDelivery ? getProductCounterMax(product) > 0 : true;

  const isChecked = useCallback(
    (product: IProductPick) =>
      isForDelivery
        ? productsChecked?.findIndex(
          (p) => isSameItem(p?.product, product) && product?.pickup === p?.product?.pickup
        ) !== -1
        : productsChecked?.findIndex((p) => p?.product?._id === product?._id) !== -1,
    [productsChecked]
  );

  const getProductCounter = useCallback(
    (product: IProductPick) =>
      !isChecked(product)
        ? 0
        : isForDelivery
          ? productsChecked?.find((p) => isSameItem(p?.product, product) && p?.product?.pickup === product?.pickup)
            ?.counter
          : productsChecked?.find((p) => p?.product?._id === product?._id)?.counter,
    [productsChecked]
  );

  useEffect(() => {
    setCount(getProductCounter(product) || 0);
     setMaxValue(
      productsToPick?.length > 0
        ? product?.volume - (getProductCounterMax(product) || 0) + (getProductCounter(product) || 0)
        : product?.volume
    );
      setMaxDelivery( productsToPick?.find((p) => p?.product?._id == product?._id)?.counter);
  }, [product?.volume]);

  const addCounter = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => onChangeValue(e, 1);

  const removeCounter = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => onChangeValue(e, -1);

  return (
    <ContainerCounterProduct>
      <OperationButton aria-disabled={count <= 1} onClick={removeCounter} style={{ fontSize: "16px" }}>
        -
      </OperationButton>
      <InputCounter value={`${count}/${isForDelivery?maxValue: maxDelivery }`} disabled />
      {isForDelivery? (
        <OperationButton
        aria-disabled={ count >= maxValue}
        onClick={addCounter}
        style={{ fontSize: "16px" }}
      >
        +
      </OperationButton>
      ):(
        <OperationButton
        aria-disabled={ count>= maxDelivery}
        onClick={addCounter}
        style={{ fontSize: "16px" }}
        
      >
        +
      </OperationButton>
      )
      }
    </ContainerCounterProduct>
  );
}
